/* Nút "Mua ngay" ở trang chi tiết: thêm vào giỏ rồi sang thẳng thanh toán.

   Không dùng submit thứ hai trong cùng form vì product-form.js bắt sự kiện
   submit và xử như "thêm vào giỏ" bình thường — sẽ không sang được checkout.

   BẮT SỰ KIỆN Ở CẤP DOCUMENT chứ không gắn vào từng nút: theme dựng lại khối
   product-info mỗi khi đổi biến thể, nút cũ bị thay bằng nút mới nên listener
   gắn trực tiếp mất sạch — đo trên site thật: nút vẫn còn cờ data-...-ready
   nhưng bấm không chạy gì. Bắt ở document thì DOM có dựng lại bao nhiêu lần
   cũng vẫn ăn. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-egr-buynow]');
    if (!btn || btn.disabled) return;

    var form = btn.closest('form');
    if (!form) return;

    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-loading');

    var data = new FormData(form);
    // product-form.js vô hiệu hoá ô id lúc chưa dùng tới -> bật lại để chắc
    var idField = form.querySelector('[name="id"]');
    if (idField && idField.disabled) data.set('id', idField.value);

    fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        // Shopify trả về "status" khi từ chối (hết hàng, sai biến thể...)
        if (res && res.status) {
          hienLoi(form, res.description || res.message || 'Không thêm được sản phẩm.');
          moKhoa(btn);
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function () {
        hienLoi(form, 'Mạng đang trục trặc, thử lại giúp mình nhé.');
        moKhoa(btn);
      });
  });

  function moKhoa(btn) {
    btn.disabled = false;
    btn.classList.remove('is-loading');
  }

  /* Mượn luôn khối báo lỗi sẵn có của theme để thông báo nằm đúng chỗ khách
     đang nhìn, thay vì bật alert */
  function hienLoi(form, msg) {
    var host = form.closest('product-form') || form.parentElement;
    var wrap = host && host.querySelector('.product-form__error-message-wrapper');
    var slot = wrap && wrap.querySelector('.product-form__error-message');
    if (wrap && slot) {
      slot.textContent = msg;
      wrap.removeAttribute('hidden');
    }
  }
})();
